import { IDWarehouseLookupLayout, IDShipViaLookupLayout, IDEquipmentLookupLayout, IDWorkerLookupLayout } from '../../../../common/lookups/Layouts/IdLayouts';
import { IMLocationLookupLayout } from '../../../../common/lookups/Layouts/ImLayouts';
import { WMCodesLookupLayout } from '../../../../common/lookups/Layouts/WMLayouts';
import { WM } from '../../../../const/constants';
import { LocationTypes } from '../../../../enum/Enum';

export const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "DeliveryPickupPlannedDateTime",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "RPlanWarehouse",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Warehouse",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            
        ]
    },
    {
        "groupId": 1,
        "fields": [
            {
                "name": "TransactionType",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Type",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "StatusFilter",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },{
        "groupId": 1,
        "fields": [
            {
                "name": "SchedStatus",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Sched Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },{
                "name": "Customer",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Customer",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 1,
        "fields": [
            {
                "name": "CustomerName",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Customer Name",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "TransactionNumber",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 1,
        "fields": [
            {
                "name": "Container",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Container",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
];

export const PrimaryLayout = (locationLayout) => [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "R_PROFILE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Profile",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "R_CUSTOMER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Customer",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "TRANSACTIONNUMBER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "SHIPPERBOLNUMBER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper's BOL #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "R_PLANWAREHOUSE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Warehouse",
                "type": "lookup",
                "layout": IDWarehouseLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "R_PLANLOCATION",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Dock",
                "type": "lookup",
                "layout": locationLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "DELIVERYPICKUPPLANNEDDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Plan From",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "DELIVERYPICKUPARRIVEDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Plan To",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "R_CARRIER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Carrier Id",
                "type": "lookup",
                "layout": IDShipViaLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "R_TRANSPORTCARRIER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Trans Carrier",
                "type": "lookup",
                "layout": IDShipViaLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "R_EQUIPMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Equipment",
                "type": "lookup",
                "layout": IDEquipmentLookupLayout({ equipmenttype: 'P' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "TRUCKREFERENCE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference#",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "CONTAINER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Container",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "EQUIPMENTINTERCHANGEREPORT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Trailer # / EIR",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "COMMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "DELIVERYPICKUPDEPARTDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Yard Arrive",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "TRUCKARRIVALDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Dock Start",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "TRUCKDEPARTDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Dock End",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "TRANSPORTATIONYARDLEAVEDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Yard Leave",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "PICKBYPLANDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Pick By",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "LOADBYPLANDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Load By",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "R_UNLOADPICKBY",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Unload By",
                "type": "lookup",
                "layout": IDWorkerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "R_CHECKBY",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Check By",
                "type": "lookup",
                "layout": IDWorkerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "R_PUTAWAYBY",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Put Away By",
                "type": "lookup",
                "layout": IDWorkerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "R_LOADBY",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Load By Worker",
                "type": "lookup",
                "layout": IDWorkerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "R_PICKBY",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Pick By Worker",
                "type": "lookup",
                "layout": IDWorkerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "WAITTIME",
                "tableName": "",
                "label": "Wait Time",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "DOCKTIME",
                "tableName": "",
                "label": "Dock Time",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "YARDTIME",
                "tableName": "",
                "label": "Yard Time",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "R_STAGINGWAREHOUSE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Staging Warehouse",
                "type": "lookup",
                "layout": IDWarehouseLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "R_STAGINGAREA",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Staging Area",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "PLANNEDRECEIVEDSHIPPEDDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Staging Planned",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "STAGINGSTARTDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Staging Start",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "STAGINGENDDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Staging End",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
];

export const CommentsLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "PLANCOMMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Plan Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "DELIVERYPICKUPCOMMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Delivery Pickup Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
];

export const UserDefinedLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "USERDEFINEDCODE1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code 1",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '03' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDCODE2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code 2",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '04' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDCODE3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code 3",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '05' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDCODE4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code 4",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '06' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDCODE5",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code 5",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '07' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDCODE6",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code 6",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '08' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDCODE7",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code 7",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '09' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDCODE8",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code 8",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '10' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDCODE9",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code 9",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '11' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDCODE10",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Code 10",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '12' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "USERDEFINEDREFERENCE1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDREFERENCE2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDREFERENCE3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDREFERENCE4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDREFERENCE5",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDREFERENCE6",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDREFERENCE7",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDREFERENCE8",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDREFERENCE9",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "USERDEFINEDREFERENCE10",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
];
